import { useMediaQuery, useTheme, Box } from '@mui/material';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';

type ChartDataItem = {
  name: string;
  aufwaende: number;
  stundenFakturierbar: number;
  stundenNichtFakturierbar: number;
};

export function RechartTabelle({
  data,
  mode,
}: {
  data: ChartDataItem[];
  mode: 'aufwaende' | 'stunden';
}) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

  const formatNumber = (value: number) =>
    mode === 'stunden' ? `${value.toFixed(2)} h` : value.toLocaleString('de-DE');

  return (
    <Box sx={{ flex: 1, height: 300 }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} margin={{ top: 20, right: 20, left: 10, bottom: 30 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="name"
            interval={isSmallScreen ? 1 : 0}
            angle={isSmallScreen ? -35 : 0}
            textAnchor={isSmallScreen ? 'end' : 'middle'}
            height={isSmallScreen ? 60 : 30}
            tick={{ fontSize: isSmallScreen ? 11 : 12 }}
          />
          <YAxis />
          <Tooltip formatter={value => formatNumber(Number(value ?? 0))} />
          <Legend />

          {mode === 'aufwaende' && (
            <Bar dataKey="aufwaende" name="Aufwände" fill={theme.palette.secondary.main} />
          )}

          {mode === 'stunden' && (
            <>
              <Bar
                dataKey="stundenFakturierbar"
                stackId="stunden"
                name="Fakturierbar"
                fill={theme.palette.secondary.main}
              />
              <Bar
                dataKey="stundenNichtFakturierbar"
                stackId="stunden"
                name="Nicht fakturierbar"
                fill={theme.palette.primary.main}
              />
            </>
          )}
        </BarChart>
      </ResponsiveContainer>
    </Box>
  );
}
